export const TEXT={
    Sessions:{en:"Sessions",ar:"الجلسات"},
    Going:{en:"Going",ar:"اللي رايحين"},
    Returning:{en:"Returning",ar:"اللي راجعين"},
    Missing:{en:"Missing",ar:"اللي مش موجودين"},
    Name:{en:"Name",ar:"الاسم"},
    Class:{en:"Class",ar:"الصف"},
    Address:{en:"Address",ar:"العنوان"},
    Import:{en:"Import database",ar:"استيراد البيانات"},
    Export:{en:"Export database",ar:"توريد البيانات"},
}

export default TEXT